<template>
  <a-cascader
    :options="options"
    :load-data="loadData"
    :loading="loading"
    placeholder="请选择地区"
    @change="onChange"
    :disabled="disabled"
    :fieldNames="{ label: 'areaName', value: 'areaCode', children: 'children' }"
    :default-value="checked"
    :size="size"
  />
</template>
<script>
export default {
  props: {
    checked: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      loading: false,
      options: [],
    }
  },
  mounted() {
    this.queryArea('country', -1)
  },
  methods: {
    queryArea(level, code, targetOption) {
      this.loading = true
      this.$api.match
        .areaInfo(level, code)
        .then((res) => {
          if (res.status === 0) {
            if (!targetOption) {
              this.options = res.data
            } else {
              targetOption.children = res.data
            }
            if (
              this.checked.length > 0 &&
              this.checked[0] != undefined &&
              this.checked[1] != undefined &&
              this.checked[2] != undefined &&
              this.checked[3] != undefined
            ) {
              let checkCode = 0
              if ('country' == level && this.checked[0]) {
                checkCode = this.checked[0]
              } else if ('province' == level && this.checked[1]) {
                checkCode = this.checked[1]
              } else if ('city' == level && this.checked[2]) {
                checkCode = this.checked[2]
              } else if (this.checked[3]) {
                checkCode = this.checked[3]
              }
              let selectedOption = null
              res.data.forEach((item) => {
                if (item.areaCode == checkCode) {
                  selectedOption = item
                  return true
                }
              })
              this.loadData([selectedOption])
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally((_) => {
          this.loading = false
        })
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      const areaLevel = targetOption.areaLevel
      let childLevel = this.computeChildLevel(areaLevel)
      this.queryArea(childLevel, targetOption.areaCode, targetOption)
    },
    onChange(value) {
      this.$emit('change', value)
    },
    computeChildLevel(areaLevel) {
      let childLevel = 'default'
      if ('country' === areaLevel) {
        childLevel = 'province'
      } else if ('province' === areaLevel) {
        childLevel = 'city'
      } else if ('city' == areaLevel) {
        childLevel = 'district'
      }
      return childLevel
    },
    reset() {
      this.queryArea('country', -1)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/comm/components/public/AreaChoice.vue